import { CLINIC_PHONE_WHATSAPP } from './clinic.config';

/** Normalize PK phone to WhatsApp format (923XXXXXXXXX). */
export const normalizeWaPhone = (phone) => {
  let digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 11 && digits.startsWith('0')) {
    digits = `92${digits.slice(1)}`;
  }
  if (digits.length === 10 && digits.startsWith('3')) {
    digits = `92${digits}`;
  }
  return digits;
};

/** Free Click-to-Chat link — opens WhatsApp with pre-filled text. */
export const buildWaMeLink = (phone, text) => {
  const digits = normalizeWaPhone(phone);
  if (!digits || !text) return '';
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

export const adminWaPhone = () => CLINIC_PHONE_WHATSAPP || '923435447588';

export const openWhatsAppLink = (url) => {
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
};

export const orderItemsPlain = (items = []) =>
  (items || [])
    .map((i) => {
      const name = i.name || 'Item';
      const qty = i.quantity || 0;
      const line = (Number(i.price) || 0) * qty;
      return `- ${name} x${qty} (Rs. ${line.toFixed(2)})`;
    })
    .join('\n') || 'No items';

/** Admin opens this to message the customer about payment verified. */
export const customerPaymentVerifiedWaLink = (order) => {
  const phone = order.phone || order.user_phone || '';
  const name = order.user_name || 'Customer';
  const text = `AlamCareRx\n\nHi ${name},\nYour payment for order #${order.id} has been verified.\nWe are now processing your order.`;
  return buildWaMeLink(phone, text);
};

export const customerShippedWaLink = (order) => {
  const phone = order.phone || order.user_phone || '';
  const name = order.user_name || 'Customer';
  const text = `AlamCareRx\n\nHi ${name},\nYour order #${order.id} has been shipped.\nIt is on the way. Track status in My Orders.`;
  return buildWaMeLink(phone, text);
};

export const customerDeliveredWaLink = (order) => {
  const phone = order.phone || order.user_phone || '';
  const name = order.user_name || 'Customer';
  const text = `AlamCareRx\n\nHi ${name},\nYour order #${order.id} has been delivered.\nThank you for shopping with AlamCareRx!`;
  return buildWaMeLink(phone, text);
};

/** Customer opens this to notify the shop of a new order (fallback if API link missing). */
export const adminNewOrderWaLink = (order) => {
  const items = orderItemsPlain(order.items);
  const total = Number(order.total || 0).toFixed(2);
  const text =
    `AlamCareRx — New Order #${order.id}\n\n` +
    `Customer: ${order.user_name || order.name || ''}\n` +
    `Phone: ${order.phone || ''}\n` +
    `Total: Rs. ${total}\n\n${items}`;
  return buildWaMeLink(adminWaPhone(), text);
};
